import React from 'react';
import clsx from 'clsx';
import { ListItem } from '../list';
import styles from './styles.module.css';
/**
 * Компонент `<MenuItem />` используется для создания элементов внутри `<Menu />`
 */
export const MenuItem = ({
  className,
  ...props
}) => (/*#__PURE__*/React.createElement(ListItem, {
  className: clsx(styles.menuItem, className),
  ...props
}));